/*
/*
    Функции аналитики
*/

export function analyticsClickEvent(btn) {
    if (btn.data('label')) {
        dataLayer.push({
            'event': 'gtm-event',
            'gtm-event-category': btn.data('cat'),
            'gtm-event-action': btn.data('action'),
            'gtm-event-label': btn.data('label'),
            'gtm-event-non-interaction': 'False'
        });
    } else {
        dataLayer.push({
            'event': 'gtm-event',
            'gtm-event-category': btn.data('cat'),
            'gtm-event-action': btn.data('action'),
            'gtm-event-non-interaction': 'False'
        });
    }
}


export function analyticsSuccessForm() {
    dataLayer.push({
        'event': 'gtm-event',
        'gtm-event-category': 'form',
        'gtm-event-action': 'sent',
        'gtm-event-non-interaction': 'False'
    });
}

export function analyticsFieldFocus(_field) {
    dataLayer.push({
        'event': 'gtm-event',
        'gtm-event-category': 'form',
        'gtm-event-action': 'focus',
        'gtm-event-label': _field.attr('name'),
        'gtm-event-non-interaction': 'False'
    });
}

export function analyticsCheckboxFocus(_field, _type) {
    dataLayer.push({
        'event': 'gtm-event',
        'gtm-event-category': _type,
        'gtm-event-action': 'choice',
        'gtm-event-label': _field.siblings('span').html(),
        'gtm-event-non-interaction': 'False'
    });
}

export function analyticsRunHandle() {
    dataLayer.push({
        'event': 'gtm-event',
        'gtm-event-category': 'trigger',
        'gtm-event-action': 'click',
        'gtm-event-label': 'push',
        'gtm-event-non-interaction': 'False'
    });
}


// WEBPACK FOOTER //
// ./_src/js/modules/Analytics.js